module.exports = __webpack_public_path__ + "img/n_zuji_on.28adc68e.png";